import React, { useEffect } from "react";
import { generatePageHeaderName } from "@frameworks/salesjourney/components/Generic/TransparentHeader/TransparentHeader";
import { useNavigate } from "react-router-dom";
import config from "@frameworks/salesjourney/config/domain";
var EmbeddedPerrComp = function (props) {
    var navigate = useNavigate();
    var quoteUrl = "".concat(config.quotesBase, "quotes/rm-quotes/peer-comparison?prefered_site=new");
    var peerCompObj = {
        checkedList: [
            {
                schemeCode: "38446",
                schemeName: "Tata Small Cap Fund - Direct (G)",
                isin: "INF277K011O1",
                schCd: "TASCFGZ-GR",
            },
            {
                schemeCode: "41072",
                schemeName: "ITI Small Cap Fund - Direct (G)",
                isin: "INF00XX01747",
                schCd: "ITSCG1-GR",
            },
            {
                schemeCode: "38349",
                schemeName: "Invesco India Smallcap Fund - Direct (G)",
                isin: "INF205K013T3",
                schCd: "RGSCD1-GR",
            },
        ],
        page: "mutualFunds",
    };
    useEffect(function () {
        localStorage.setItem("checkedListDetails", JSON.stringify(peerCompObj));
        !!props.setHeaderLeftComponent &&
            props.setHeaderLeftComponent(React.createElement("div", { className: "d-flex align-items-center gap-4" },
                React.createElement("span", { onClick: function () {
                        return navigate("/dashboard/product-bouquet?productCode=56&categoryCode=261");
                    } },
                    React.createElement("i", { className: "edel-icon-left-arrow txt_white hand_cursor" })),
                generatePageHeaderName("Peer Comparision")));
    }, []);
    return (React.createElement("div", { className: "rm-quotes iframeoutersection" },
        React.createElement("iframe", { className: "iframeClass", src: quoteUrl })));
};
export default EmbeddedPerrComp;
